<template>
    <div class="list">
        <div style="width: 100%"
             v-for="(item1,index1) in newForm"
             :key="index1"
             class="common-txt">
            <div class="title-box" @click="handleSelectTitle(index1)" >
                <!--<p class="type-name"-->
                   <!--:class="{'active': newSelected.includes(index1)}"-->
                <!--&gt;-->
                    <!--<span class="name">{{item1.title}}</span>-->
                    <!--<span class="iconfont icon-xuanze_xianxing_xiala"></span>-->
                <!--</p>-->
            </div>
            <div
                    v-if="index1 === 0"
                    class="item-box"
                    :style="`
                        ${newSelected.includes(index1)?
                        `height: ${Math.ceil((item1.data.length)/item1.column) * 98 + (isLastPage?60:0)}px`:''}
                        ${!isLastPage?'min-height:'+minHeight+'px;': ''}
                        `"
            >
                <div class="blank-box" v-if="item1.data.length === 0">
                    <img class="img" :src="$images.global.blank" alt="img" />
                    <span class="word">暂无数据</span>
                </div>
                <div
                v-for="(item,index) in item1.data"
                :key="index"
                class="item"
                :class="{'active': `${item.id}`===`${selectedActive && selectedActive.id}`}"
                @click.stop="handleSelectItem(item, index, index1)">
                    <AudioBox
                        :item.sync="item"
                        :index.sync="index"
                        :index1.sync="index1"
                        @handlePlay="handlePlay"
                        @handleStatus="handleStatus"
                        @handleSelectItem="handleSelectItem"
                        @handleSetBackground="handleSetBackground"
                    />
        </div>
                <p v-if="isLastPage && newForm.length" class="last-info">{{$enums.configInfo.moreInfo}}</p>
                <!--<p class="item more"-->
                   <!--v-if="item1.page && item1.last_page && item1.page<item1.last_page"-->
                   <!--@click.stop="handleMore(item1)"-->
                <!--&gt;<span class="sp-more">更多展示</span></p>-->
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import {AudioPlay, AudioPause, AudioAllTime} from "../../../../../../../../utils/audio";
    import AudioBox from './components/audioBox'

    export default {
        name: "select-list",
        components: {
            AudioBox
        },
        props: {
            minHeight: [Number, String],
            isShop: {
                type: Boolean,
                default: false
            },
            form: Array,
            selected: Array
        },
        computed: {
            ...mapState(['menusData']),
            isLastPage(){
                let state = false
                try {
                    const data = this.$_.cloneDeepWith(this.newForm)
                    const item1 =  data[0]
                    state = item1.page && item1.last_page && item1.page >= item1.last_page
                } catch (e) {
                    console.log('获取isLastPage2==>', e)
                }
                return state
            }
        },
        watch:{
            form(vl){this.newForm = vl},
            newForm:{
                handler(vl) {
                    this.$emit('update:form', vl)
                    this.$emit('onSelectList', vl)
                },
                deep: true
            },
            selected(vl){this.newSelected = vl},
            newSelected(vl){this.$emit('update:selected', vl)},
        },
        data(){
            return {
                isLoading: false,
                newSelected: this.selected,
                newForm: this.form,
                selectedActive: {
                    id: '',
                    index: ''
                },
                isSelected: false // 当前是否选中 播放
            }
        },
        methods: {
            scrollTodo(){
                // 1.如果 滚动的距离 === 文本实际渲染高度【contentHeight】 - 浏览器可视高度【boxHeight】
                // 2.加载下一页
                if(
                    !this.isLastPage &&
                    !this.isLoading
                ){
                    this.isLoading = true
                    this.handleMore(this.newForm[0])
                    this.isLoading = false
                }
            },
            // 更多
            handleMore(item){
                console.log('更多')
                this.$emit('onMoreSelectList', item)
            },
            async handleSelectTitle(index1){
                console.log('选择标题==>', index1, this.newForm)
                // if(this.newSelected.includes(index1)){
                //     this.newSelected.splice(this.newSelected.indexOf(index1), 1)
                // }else{
                //     this.newSelected.push(index1)
                // }
                // 判断展开数据是否有数据，如果没有，请求数据
                if(this.newForm[index1].data.length === 0){
                    let config = this.newForm[index1].apiConfig
                    const data = await config.request(config.params)
                    let url = ''

                    this.newForm[index1].page = data.meta.current_page
                    this.newForm[index1].last_page = data.meta.last_page
                    this.newForm[index1].data = data.items.map(q => {
                        url = q.attributes.resources && q.attributes.resources.url
                        if (q.attributes.cover) url = q.attributes.cover
                        if (q.attributes.h5_remote) url = q.attributes
                        return {
                            url,
                            ...q
                        }
                    })
                }

                if(this.selected.includes(index1)){
                    this.selected.splice(this.selected.indexOf(index1), 1)
                }else{
                    this.selected.push(index1)
                }

                if(this.newForm[index1].data.length === 0){
                    // this.$message.error('该分类无数据')
                }
            },
            handleSelectItem(item, index, index1){
                console.log('handleSelectItem==>2')
                // let isOld = false
                try {
                    if(item.id === this.selectedActive.id &&
                        index === this.selectedActive.index &&
                        index1 === this.selectedActive.index1){
                        // isOld = true
                    }
                }catch (e) {
                    console.log('判断失败==>', e)
                }
                // 选中即可播放
                // this.handlePlay(item,index,index1,isOld)

                this.selectedActive = {id: item.id, index, index1}
                // 将未选中全部设置成待播放
                let data = this.$_.cloneDeepWith(this.newForm)
                data.map((v,i)=>{
                    if(index1 !== i){
                        v.data.map(q=>q.play = false)
                    }
                })
                data[index1].data.map((v,i)=>{if(index!==i)v.play = false})
                this.newForm = data

                // 关闭背景音弹窗
                this.$emit('closeBackAudio')
            },
            handlePlay(item,index,index1,isOld){
                console.log("播放");
                let state = this.newForm[index1].data[index].play
                if(!state){
                    AudioPlay({url:item.url, isOld})
                }else{
                    AudioPause()
                }
                let data = this.$_.cloneDeepWith(this.newForm)
                data.map((v,i)=>{
                    if(index1 !== i){
                        v.data.map(q=>q.play = false)
                    }
                })
                data[index1].data[index].play = !item.play
                this.newForm = data
                // 关闭背景音弹窗
                this.$emit('closeBackAudio')
            },
            handleLove(item,index,index1){
                let data = this.$_.cloneDeepWith(this.newForm)
                data[index1].data[index].love = !item.love
                this.newForm = data
            },
            handleSetBackground(item,index,index1){
                // 游戏环节判断是否支持添加
                if(this.menusData.lessonSelectedConfig?.type === 'game'){
                    this.$message.warning(this.$enums.warnType.game)
                    return false
                }
                // PPT环节判断是否支持添加
                if(this.menusData.lessonSelectedConfig?.type === 'html'){
                    this.$message.warning(this.$enums.warnType.ppt)
                    return false
                }
                this.handleStatus(item,index,index1, 'bgm')
                // 关闭背景音弹窗
                this.$emit('closeBackAudio')
            },
            handleStatus(item,index,index1, audioType){
                // 游戏环节判断是否支持添加
                if(this.menusData.lessonSelectedConfig?.type === 'game'){
                    this.$message.warning(this.$enums.warnType.game)
                    return false
                }
                // PPT环节判断是否支持添加
                if(this.menusData.lessonSelectedConfig?.type === 'html'){
                    this.$message.warning(this.$enums.warnType.ppt)
                    return false
                }
                let data = this.$_.cloneDeepWith(this.newForm)
                data[index1].data[index].status = true
                this.newForm = data

                // 向cocos通知 添加/删除
                /**
                 game: 游戏
                 resources: 资源
                 shop-resources: 公共资源（资源商城）
                 * */
                let type = 'resources'
                if(this.isShop) type = 'shop-resources'

                console.log('777=>', data, index1, index)

                // 播放一次音频，并获取音频长
                AudioPlay({url: item.url})
                AudioAllTime((duration)=>{
                    if(data[index1].data[index].status) {
                        let obj = {
                            type: 'AddResource',
                            value: {'type': 'audio', url: item.url, duration: duration.seconds}
                        }
                        // 设置为背景音
                        if(audioType){
                            obj.value = {
                                name: item.alias || item.name,
                                isShow: false,
                                isBackground: false,
                                isLoop: false,
                                'type': audioType,
                                url: item.url,
                                duration: duration.seconds
                            }
                        }
                        this.$toCocosMessage(obj)
                        this.$store.dispatch('setUrlMap',{mark:'service-map-object', type, id: item.id,url: this.$utils.getAllMd5({data: item.url})[0]})
                    }else{
                        this.$toCocosMessage({
                            type: 'DelResource',
                            value: {'type': 'audio', url: item.url, duration: duration.seconds}
                        })
                    }
                })
                // 关闭背景音弹窗
                this.$emit('closeBackAudio')
            }
        }
    }
</script>

<style lang="scss" scoped>
.list{
    display: flex;
    flex-direction: column;
    width: 100%;
    user-select: none;
    padding-bottom: 50px;

    .title-box{
        cursor: pointer;

        &:hover {
            /*background-color: #ff00ff;*/
        }
    }
    .type-name{
        font-size: 14px;
        width: 100%;
        color: #393500;
        border-radius: 10px;
        margin: 8px 0px;
        text-align: left;
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .iconfont{
            font-size: 12px;
            transform: scale(.6);
            transition: all .2s linear;
        }

        &.active{
            .iconfont {
                transform: scale(.6) rotateZ(-180deg);
            }
        }
    }
    .item-box {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        margin: 10px 0px;
        height: 0px;
        overflow: hidden;
        transition: all .2s linear;
        align-content: flex-start;


        .last-info{
            width: 100%;
            font-size: 14px;
            font-weight: 400;
            color: #656773;
            line-height: 60px;
            text-align: center;
        }


        .item.more{
            display: flex;
            width: 100%;
            justify-content: center;
            align-items: center;
            line-height: 30px;
            height: 30px;
            cursor: pointer;
            background:rgba(245,247,250,1);
            border-radius:4px;
            border:1px solid rgba(220,223,230,1);
            font-size: 12px;
            color:rgba(51,51,51,1);

            &:hover {
                border:1px solid rgba(220,223,230,1);
            }
            &:active{
                opacity: .5;
            }

            .sp-more{
                color: white;
            }
        }

        .blank-box{
            width: 100%;
            min-height: 30vh;
            display: flex;
            flex: 1;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .img {
                display: flex;
                flex-shrink: 0;
            }
            .word {
                font-size: 14px;
                color: #656773;
                margin-top: 6px;
                position: relative;
                left: -2px;
            }
        }

        &.show {
            height: 100%;
        }

        .item {
            width: 100%;
            height: 60px;
            margin-bottom: 10px;
            transition: all .2s linear;

            border:1px solid rgba(232,232,232,1);
            background:rgba(245,247,250,1);
            border-radius:4px;

            &:hover, &.active {
                cursor: pointer;
                border:1px solid #e7622e;
            }

            .title-box {
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                .name {
                    height: 18px;
                    font-size: 14px;
                    color: rgba(51, 51, 51, 1);
                    padding-left: 10px;
                    padding-top: 6px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 212px;
                }

                .time {
                    font-size: 14px;
                    padding-right: 10px;
                    padding-top: 6px;
                }
            }

            .btn-box {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                padding: 6px 10px 0px;

                .btns {
                    display: flex;
                    flex-direction: row;

                    .btn {
                        margin-right: 15px;
                    }
                }

                .btn {
                    cursor: pointer;

                    &.play > img {
                        width: 20px;
                        height: 21px;
                    }

                    &.love > img {
                        width: 20px;
                        height: 18px;
                        margin-top: 1px;
                    }

                    &.select-box > img {
                        width: 18px;
                        height: 19px;
                    }
                }
            }
        }
    }
}
</style>
